import { sendRequest, setToken } from '../../utils/http-request';
import { StateType } from '../../types';
import { FuelSite } from '../../types';

async function authenticateCustomer(
  accountNumber: string,
  firstName: string,
  lastName: string,
  dateOfBirth: string
) {
  return sendRequest('post', `customer/${accountNumber}`, {
    firstName: firstName,
    lastName: lastName,
    dateOfBirth: dateOfBirth,
  });
}

async function getCustomerFuelSites(
  stateShortName: StateType,
  accountNumber: string
) {
  return sendRequest('get', `customer/${accountNumber}/site`);
}

export async function authenticate(
  stateShortName: StateType,
  accountNumber: string,
  firstName: string,
  lastName: string,
  dateOfBirth: string
) {
  try {
    const customer = await authenticateCustomer(
      accountNumber,
      firstName,
      lastName,
      dateOfBirth
    );

    if (!customer.data.supportsDirectDebit) {
      const error = {
        response: {
          data: {
            isLockedOut: false,
            message: 'WA Unauthorised',
          },
        },
      };
      throw error;
    }

    setToken(customer.data.authenticationToken);

    const result = await getCustomerFuelSites(stateShortName, accountNumber);
    const fuelSites: FuelSite[] = result.data.map((site: any) => {
      return {
        fuelType: site.fuelType,
        accountNumber: site.accountNumber,
        authAccountNumber: accountNumber,
      };
    });

    return {
      data: {
        accountNumber,
        firstName: customer.data.firstName,
        lastName: customer.data.lastName,
        dateOfBirth: customer.data.dateOfBirth,
        authenticationToken: customer.data.authenticationToken,
        fuelSites,
      },
    };
  } catch (error) {
    throw error;
  }
}
